$shm_hitalama_process_view $mol_view
	host null
	method null
	method_name \
	last $shm_hitalama_process
	state null
	result null
	started_at \
	finished_at \
	error_message \
	sub /
		<= Head $mol_view
			sub /
				<= Title $mol_view
					sub / \Process
				<= Method $mol_view
					sub / <= method_title \
		<= Stats $mol_view
			sub /
				<= Stat_total $mol_view
					sub /
						<= Stat_total_label $mol_view
							sub / \Calls
						<= Stat_total_value $mol_view
							sub / <= calls_count \
				<= Stat_last $mol_view
					sub /
						<= Stat_last_label $mol_view
							sub / \Last
						<= Stat_last_value $mol_view
							sub / <= status \
				<= Stat_duration $mol_view
					sub /
						<= Stat_duration_label $mol_view
							sub / \Duration
						<= Stat_duration_value $mol_view
							sub / <= duration \
		^ running_fiber_visible / <= Running_fiber_row $mol_view
			sub /
				<= Running_fiber_copy $shm_button_copy
					button_sub / <= Running_fiber_copy_icon $mol_icon_content_copy
					text <= running_fiber_trace \
				<= Running_fiber $mol_text
					text <= running_fiber_trace \
					code_sidebar_showed false
		<= Promise_str $mol_view sub / <= promise_str \
		^ empty_visible / <= Empty $mol_view
			sub / \No process calls yet
		<= Calls $mol_list
			sub <= call_cards /
	Call_card* $mol_view
		sub /
			<= Call_head* $mol_view
				sub /
					<= Call_status* $mol_view
						sub / <= call_status*
					<= Call_name* $mol_view
						sub / <= call_name*
					<= Call_duration* $mol_view
						sub / <= call_duration*
			<= Call_time* $mol_view
				sub / <= call_time*
			^ call_args_visible* / <= Call_args* $mol_dump_value
				value <= call_args* /
				expanded? <=> args_expanded*? false
				minimal_height 0
			^ call_result_visible* / <= Call_result* $mol_dump_value
				value <= call_result* null
				expanded? <=> result_expanded*? false
				minimal_height 0
			^ call_error_visible* / <= Call_error* $mol_dump_value
				value <= call_error* null
				expanded? <=> error_expanded*? true
				minimal_height 0
